<span style="white-space:pre;" #shadowElement>{{autosizeValue}}</span>